import styled from 'styled-components'

import {
    FlexCentered,
    hideWhenNoChildren,
} from 'components/common/genericStyles'

export const Container = styled.div`
    height: 100%;
    ${FlexCentered}
    margin-right: 15px;
`

export const ActiveSpeakerWrapper = styled.div`
    height: 100%;
    width: max-content;
    ${FlexCentered}
    margin-right: 5px;
`

export const ButtonsContainer = styled.div`
    height: 100%;
    ${FlexCentered}
`

export const ButtonWrapper = styled.div`
    height: 100%;
    ${FlexCentered}
    transition: all 0.3s ease;
    margin: 0px 8px;

    & > * {
        height: 100%;
        width: 48px;

        transition: all 0.3s ease;
        ${FlexCentered}
    }

    ${hideWhenNoChildren}
`
